import React from "react";
import {Divider, Typography, List, Button, Stack, Avatar, Box, Drawer, Badge} from '@mui/material';

import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';

import NavigationButton from "./NavigationButton";
import TeachingMenuSnippet from "./navigation-sections/TeachingMenuSnippet";
import SupportMenuSnippet from "./navigation-sections/SupportMenuSnippet";
import ContentMenuSnippet from "./navigation-sections/ContentMenuSnippet";
import TrafficMenuSnippet from "./navigation-sections/TrafficMenuSnippet";
import QAMenuSnippet from "./navigation-sections/QAMenuSnippet";
import AdminMenuSnippet from "./navigation-sections/AdminMenuSnippet";

const styles = {
    divider: {
        my: '0.2rem'
    },
    drawerBox: {
        m: '1rem'
    },
    user: {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "0.5rem"
    },
    userName: {
        fontSize: "0.875rem"
    },
    list: {
        py: 0
    }
};

export default function NavigationDrawer({open, onClose, currentUser, onLogoutClicked, updatedShiftCount, permissions}) {
    return (
        <Drawer open={open} onClick={onClose}>
            <Box sx={styles.drawerBox}>
                <Stack sx={styles.user}>
                    <Avatar alt={currentUser?.givenName}>{currentUser?.givenName.charAt(0)} </Avatar>
                    <Typography variant="body1" sx={styles.userName}>{currentUser?.givenName} {currentUser?.familyName}</Typography>
                    <Button variant={"outlined"} onClick={onLogoutClicked} endIcon={<LogoutIcon/>}>Logout</Button>
                </Stack>

                <Divider sx={{...styles.divider, mt: '1rem'}}/>

                <List sx={styles.list}>
                    <NavigationButton displayName="Home" toLink="/">
                        <Badge color="error" overlap="circular">
                            <HomeIcon/>
                        </Badge>
                    </NavigationButton>
                    <Divider sx={styles.divider}/>

                    <TeachingMenuSnippet permissions={permissions} updatedShiftCount={updatedShiftCount}/>
                    <SupportMenuSnippet permissions={permissions}/>
                    <ContentMenuSnippet permissions={permissions}/>
                    <TrafficMenuSnippet permissions={permissions}/>
                    <QAMenuSnippet permissions={permissions}/>
                    <AdminMenuSnippet permissions={permissions}/>
                </List>
            </Box>
        </Drawer>
    );
}
